module.exports = __webpack_public_path__ + "img/0025.567e74ee.jpg";